import React from 'react';
import { Shield, AlertCircle } from 'lucide-react';

/**
 * Компонент выбора состояния здоровья
 */
const HealthConditionSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  healthConditions
}) => {
  // Найти выбранное состояние здоровья
  const selectedHealthCondition = healthConditions.find(c => c.id === formData.healthCondition);
  
  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Shield className="w-5 h-5 mr-2 text-blue-500" />
        Состояние здоровья
      </h3>
      
      <div className="grid grid-cols-1 gap-4">
        <div>
          <label htmlFor="healthCondition" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Выберите состояние здоровья
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {healthConditions.map((condition) => (
              <label
                key={condition.id}
                className={`relative flex items-center p-3 border rounded-lg cursor-pointer transition-colors
                  ${formData.healthCondition === condition.id 
                    ? 'bg-blue-100 border-blue-300 dark:bg-blue-900/30 dark:border-blue-700' 
                    : 'bg-white dark:bg-gray-700 border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600'}`
                }
              >
                <input
                  type="radio"
                  name="healthCondition"
                  value={condition.id}
                  checked={formData.healthCondition === condition.id}
                  onChange={handleInputChange}
                  className="form-radio hidden"
                />
                <div>
                  <p className={`text-sm font-medium 
                    ${formData.healthCondition === condition.id 
                      ? 'text-blue-700 dark:text-blue-300' 
                      : 'text-gray-700 dark:text-gray-300'}`
                  }>
                    {condition.name}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                    {condition.description}
                    {condition.adjustment !== 0 && ` (${condition.adjustment > 0 ? '+' : ''}${condition.adjustment}%)`}
                  </p>
                </div>
              </label>
            ))}
          </div>
          {errors.healthCondition && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.healthCondition}
            </p>
          )}
        </div>
      </div>

      {/* Предупреждение о влиянии состояния здоровья */}
      {selectedHealthCondition && selectedHealthCondition.id !== 'healthy' && (
        <div className="mt-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-3 flex items-start">
          <AlertCircle className="text-yellow-500 dark:text-yellow-400 w-5 h-5 mr-2 flex-shrink-0 mt-0.5" />
          <div className="text-sm text-yellow-700 dark:text-yellow-300">
            <p className="font-medium mb-1">Важно!</p>
            <p className="text-xs">
              При наличии {selectedHealthCondition.name.toLowerCase()} требуется индивидуальный подход к тренировкам. 
              Применена корректировка {selectedHealthCondition.adjustment}% к расчету максимального пульса для обеспечения безопасности.
              Обязательно проконсультируйтесь с врачом перед началом тренировок.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default HealthConditionSection;